import {
    Button,
    ConfirmModal,
} from "@mrflark/ui";
import {
    useState,
} from "preact/compat";
import type {
    ReactElement,
} from "preact/compat";

type ClearQueueButtonProps = {
    onCleared?: () => void;
};

export const ClearQueueButton = (
    { onCleared }: ClearQueueButtonProps = {},
): ReactElement => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClear = async (): Promise<void> => {
        setLoading(true);
        try {
            const response = await fetch("/api/admin/jobs/clear", {
                method: "POST",
            });
            if (response.ok) {
                onCleared?.();
            }
        } finally {
            setLoading(false);
            setShowConfirm(false);
        }
    };

    return (
        <>
            <Button
                variant="error"
                size="sm"
                onClick={() => setShowConfirm(true)}
            >
                Clear
            </Button>
            <ConfirmModal
                isOpen={showConfirm}
                onClose={() => setShowConfirm(false)}
                onConfirm={handleClear}
                title="Clear job queue"
                message="Delete all non-processing jobs from the queue?"
                confirmText="Clear"
                variant="danger"
                isLoading={loading}
            />
        </>
    );
};
